'use strict';exports.__esModule = true;exports.setOtherCompanyPropertiesSliderConfig = exports.loadOtherCompanyProperties = undefined;var _axios = require('axios');var _axios2 = _interopRequireDefault(_axios);
var _get = require('lodash/get');var _get2 = _interopRequireDefault(_get);
var _reduxAct = require('redux-act');
var _reduxLoop = require('redux-loop');
var _formatApiError = require('../../helpers/formatApiError');var _formatApiError2 = _interopRequireDefault(_formatApiError);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}var

promise = _reduxLoop.Effects.promise;

var loadOtherCompanyProperties = (0, _reduxAct.createAction)('/LOAD_OTHER_COMPANY_PROPERTIES');
var loadOtherCompanyPropertiesSuccess = (0, _reduxAct.createAction)('/LOAD_OTHER_COMPANY_PROPERTIES_SUCCESS');
var loadOtherCompanyPropertiesFail = (0, _reduxAct.createAction)('/LOAD_OTHER_COMPANY_PROPERTIES_FAIL');
var setOtherCompanyPropertiesSliderConfig = (0, _reduxAct.createAction)('/SET_OTHER_COMPANY_SLIDER_CONFIG');

var fetchLoad = function fetchLoad(_ref) {var _ref$type = _ref.type,type = _ref$type === undefined ? 'properties' : _ref$type,_ref$params = _ref.params,params = _ref$params === undefined ? {} : _ref$params;return _axios2.default.get('/' + type + '/search?$limit=20', {
    params: params }).

  then(loadOtherCompanyPropertiesSuccess, loadOtherCompanyPropertiesFail);};

var handleLoad = function handleLoad(state, action) {return (0, _reduxLoop.loop)(Object.assign({},
  state, {
    loading: true }),
  promise(fetchLoad, action));};

var handleLoadSuccess = function handleLoadSuccess(state, action) {
  var data = (0, _get2.default)(action, 'data.data');
  return Object.assign({},
  state, {
    loading: false,
    loaded: true,
    data: data });

};

var handleLoadFail = function handleLoadFail(state, action) {
  var error = (0, _formatApiError2.default)(action, 'Failed receive other company properties');

  return Object.assign({},
  state, {
    loading: false,
    loaded: false,
    data: null,
    error: error });

};

var handleSetSliderConfig = function handleSetSliderConfig(state, _ref2) {var option = _ref2.option,section = _ref2.section,index = _ref2.index;return Object.assign({},
  state, {
    sliderConfig: {
      section: section,
      index: index } });};



var initialState = {
  loaded: false,
  data: null,
  sliderConfig: {
    index: 0 } };



var otherCompanyProperties = (0, _reduxAct.createReducer)(function (on) {
  on(loadOtherCompanyProperties, handleLoad);
  on(loadOtherCompanyPropertiesSuccess, handleLoadSuccess);
  on(loadOtherCompanyPropertiesFail, handleLoadFail);
  on(setOtherCompanyPropertiesSliderConfig, handleSetSliderConfig);
}, initialState);exports.


loadOtherCompanyProperties = loadOtherCompanyProperties;exports.
setOtherCompanyPropertiesSliderConfig = setOtherCompanyPropertiesSliderConfig;exports.default =


otherCompanyProperties;


//////////////////
// WEBPACK FOOTER
// ./src/redux/modules/otherCompanyProperties.js
// module id = 3092
// module chunks = 0